import { Box, Grid, Paper, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import * as IMG from '../../helpers/ImagesUtils';
import * as ROUTES from '../../router/Routes';
import { LoadingWidget } from '../../widgets';
import { getDashboardAction } from './DashboardAction';
import BotonComponent from './components/BotonNuevo';

const DashboardCPanelView = () => {
  const dispatch = Redux.useDispatch();
  const history = useHistory();

  const dashboardStore = Redux.useSelector((state) => state.dashboard);

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await getDashboardAction(dispatch, 'cpanel', null);
      setLoading(false);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Card = (icon, text, data, to) => (
    <Grid item xs={12} md={4}>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {icon}
          <Typography variant="body" sx={{ ml: 2, fontWeight: '700' }}>
            {text}
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            mt: 1,
          }}
        >
          <Typography variant="h4">{data}</Typography>
          {to && (
            <Link
              to={to}
              style={{
                color: 'black',
                textDecoration: 'none',
              }}
            >
              <BotonComponent
                click={() => {
                  history.push(to);
                }}
                blue
                text="Ver más"
              />
            </Link>
          )}
        </Box>
      </Paper>
    </Grid>
  );

  // const indexs = dashboardStore.dashboard
  //     ? Object.keys(dashboardStore.dashboard.attributes)
  //     : null;

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={loading && !dashboardStore.dashboard}
          text="Cargando estadísticas..."
        />
      </Grid>
      {Card(
        <img src={IMG.adminm} width="25" height="25" alt="vistas" />,
        'Administradores',
        dashboardStore.dashboard?.admin ?? 0,
        ROUTES.usuarios.to,
      )}
      {Card(
        ROUTES.usuarios.icon,
        'Usuarios',
        dashboardStore.dashboard?.usuarios ?? 0,
        ROUTES.usuarios.to,
      )}
      {Card(
        ROUTES.entidades.icon,
        'Entidades',
        dashboardStore.dashboard?.entidades ?? 0,
        ROUTES.entidades.to,
      )}
      {Card(
        ROUTES.suscripciones.icon,
        'Suscripciones',
        dashboardStore.dashboard?.suscripciones ?? 0,
        ROUTES.suscripciones.to,
      )}
      {Card(
        ROUTES.docentes.icon,
        'Docentes',
        dashboardStore.dashboard?.docentes ?? 0,
        ROUTES.usuarios.to,
      )}
      {Card(
        ROUTES.estudiantes.icon,
        'Estudiantes',
        dashboardStore.dashboard?.estudiantes ?? 0,
        ROUTES.usuarios.to,
      )}
      {Card(
        <img src={IMG.familia} width="25" height="25" alt="vistas" />,
        'Familiares',
        dashboardStore.dashboard?.familiares ?? 0,
        ROUTES.usuarios.to,
      )}
    </Grid>
  );
};

export default DashboardCPanelView;
